import type { ISecondaryHeaderProps } from '../../../../interfaces/globals';
import Badge from '../../Badge/Badge';
import Breadcrumbs from '../../Breadcrumbs/Breadcrumbs';

import './SecondaryHeader.scss';

const SecondaryHeader = ({ breadcrumbItems, badgeText, badgeVariant, children, className }: ISecondaryHeaderProps) => {
  const rootClass = ['secondary-header', className].filter(Boolean).join(' ');
  return (
    <header className={rootClass}>
      <div className="secondary-header__row">
        <div className="secondary-header__breadcrumb-group">
          <Breadcrumbs items={breadcrumbItems} />
          {badgeText && <Badge variant={badgeVariant}>{badgeText}</Badge>}
        </div>
        {children !== undefined && <div className="secondary-header__actions">{children}</div>}
      </div>
    </header>
  );
};

export default SecondaryHeader;
